import { Component } from '@angular/core';

@Component({
  selector: '[editor-toolbar]',
  templateUrl: './editor-toolbar.component.html'
})
export class EditorToolbarComponent  {
}



// WEBPACK FOOTER //
// ./src/app/components/utility/editor-toolbar/editor-toolbar.component.ts